import _ from 'lodash'

interface IParseOptions {
  deep?: boolean
  doWithArrays?: boolean
}

/**
 * Function to transform subobjects of a parent object into a string containing the '_id' of the subobject. (Works with deep mode and arrays)
 * @param obj Any object to parse
 * @param options Parse options, including deep or doWithArrays config
 * @returns Parsed object
 */
export const parseSubObjectIds = <TInitialObject extends object, TParsedObject extends object>(
  obj: TInitialObject,
  options?: IParseOptions,
): TParsedObject => {
  const result: any = _.cloneDeep(obj)

  const deep = options?.deep || false
  const doWithArrays = options?.doWithArrays || false

  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'object' && !(value instanceof Array)) {
      if (!value) continue

      if (value['_id']) {
        result[key] = value['_id']
        continue
      } else if (deep) {
        result[key] = parseSubObjectIds(result[key])
        continue
      }
    }

    if (doWithArrays && typeof value === 'object' && value instanceof Array) {
      const arrayValue = result[key]

      for (const item of arrayValue) {
        if (typeof item !== 'object') continue

        if ('_id' in item) {
          arrayValue[arrayValue.indexOf(item)] = item['_id']
        } else {
          arrayValue[arrayValue.indexOf(item)] = parseSubObjectIds(item, {
            deep: true,
            doWithArrays: true,
          })
        }
      }
    }
  }

  return result
}
